import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './index.scss'
import { ColorProvider } from './context/ColorContext'

const rootElement = document.getElementById('root')
const app = ReactDOM.createRoot(rootElement)

app.render(
	// <React.StrictMode>
	<BrowserRouter>
		<ColorProvider>
			<App />
		</ColorProvider>
	</BrowserRouter>
	// </React.StrictMode>
)
